/**
 * HIP-3 Asset Registry (client-side)
 * Duplicated from config/hip3Assets.js for frontend use (no Node.js imports).
 */

export const HIP3_ASSETS = {
  // Indices
  'XYZ100':    { category: 'index',     display: 'Nasdaq 100' },
  'SP500':     { category: 'index',     display: 'S&P 500' },
  'JP225':     { category: 'index',     display: 'Nikkei 225' },
  'KR200':     { category: 'index',     display: 'KOSPI 200' },
  'DXY':       { category: 'index',     display: 'US Dollar Index' },
  'VIX':       { category: 'index',     display: 'Volatility Index' },
  // Stocks
  'TSLA':{ category: 'stock', display: 'Tesla' },
  'NVDA':{ category: 'stock', display: 'Nvidia' },
  'AAPL':{ category: 'stock', display: 'Apple' },
  'META':{ category: 'stock', display: 'Meta' },
  'MSFT':{ category: 'stock', display: 'Microsoft' },
  'GOOGL':{ category: 'stock', display: 'Google' },
  'AMZN':{ category: 'stock', display: 'Amazon' },
  'AMD':{ category: 'stock', display: 'AMD' },
  'NFLX':{ category: 'stock', display: 'Netflix' },
  'BABA':{ category: 'stock', display: 'Alibaba' },
  'COIN':{ category: 'stock', display: 'Coinbase' },
  'HOOD':{ category: 'stock', display: 'Robinhood' },
  'PLTR':{ category: 'stock', display: 'Palantir' },
  'MSTR':{ category: 'stock', display: 'MicroStrategy' },
  'INTC':{ category: 'stock', display: 'Intel' },
  'MU':{ category: 'stock', display: 'Micron' },
  'ORCL':{ category: 'stock', display: 'Oracle' },
  'COST':{ category: 'stock', display: 'Costco' },
  'LLY':{ category: 'stock', display: 'Eli Lilly' },
  'TSM':{ category: 'stock', display: 'TSMC' },
  'RIVN':{ category: 'stock', display: 'Rivian' },
  'GME':{ category: 'stock', display: 'GameStop' },
  'SOFTBANK':{ category: 'stock', display: 'SoftBank' },
  'HYUNDAI':{ category: 'stock', display: 'Hyundai' },
  'KIOXIA':{ category: 'stock', display: 'Kioxia' },
  'HIMS':{ category: 'stock', display: 'Hims & Hers' },
  'DKNG':{ category: 'stock', display: 'DraftKings' },
  'LITE':{ category: 'stock', display: 'Lumentum' },
  'BX':{ category: 'stock', display: 'Blackstone' },
  'MRVL':{ category: 'stock', display: 'Marvell' },
  'SNDK':{ category: 'stock', display: 'SanDisk' },
  'SKHX':{ category: 'stock', display: 'SK Hynix' },
  'CRCL':{ category: 'stock', display: 'Circle' },
  'CRWV':{ category: 'stock', display: 'CoreWeave' },
  'SMSN':{ category: 'stock', display: 'Samsung' },
  // Commodities
  'GOLD':{ category: 'commodity', display: 'Gold' },
  'SILVER':{ category: 'commodity', display: 'Silver' },
  'BRENTOIL':{ category: 'commodity', display: 'Brent Oil' },
  'COPPER':{ category: 'commodity', display: 'Copper' },
  'NATGAS':{ category: 'commodity', display: 'Natural Gas' },
  'URANIUM':{ category: 'commodity', display: 'Uranium' },
  'ALUMINIUM':{ category: 'commodity', display: 'Aluminium' },
  'PLATINUM':{ category: 'commodity', display: 'Platinum' },
  'PALLADIUM':{ category: 'commodity', display: 'Palladium' },
  'CORN':{ category: 'commodity', display: 'Corn' },
  'WHEAT':{ category: 'commodity', display: 'Wheat' },
  'TTF':{ category: 'commodity', display: 'EU Gas (TTF)' },
  // Forex
  'JPY':{ category: 'forex', display: 'USD/JPY' },
  'EUR':{ category: 'forex', display: 'EUR/USD' },
  // ETFs
  'EWY':{ category: 'etf', display: 'iShares S.Korea' },
  'EWJ':{ category: 'etf', display: 'iShares Japan' },
  'XLE':{ category: 'etf', display: 'Energy SPDR' },
  'URNM':{ category: 'etf', display: 'Uranium Miners' },
  'USAR':{ category: 'etf', display: 'US AR ETF' },
  // Other
  'PURRDAT':{ category: 'other', display: 'PURRDAT' },
};

const HIP3_SET = new Set(Object.keys(HIP3_ASSETS));

export function isHip3Symbol(symbol) {
  if (!symbol) return false;
  let s = symbol.toUpperCase();
  if (s.startsWith('XYZ:')) s = s.slice(4);
  if (s.endsWith('USDT')) s = s.slice(0, -4);
  if (s.endsWith('USD')) s = s.slice(0, -3);
  return HIP3_SET.has(s);
}

export function getAssetDisplayName(symbol) {
  if (!symbol) return '';
  let s = symbol.toUpperCase();
  if (s.startsWith('XYZ:')) s = s.slice(4);
  if (s.endsWith('USDT')) s = s.slice(0, -4);
  return HIP3_ASSETS[s]?.display || s;
}

export function getAssetCategory(symbol) {
  if (!symbol) return 'crypto';
  let s = symbol.toUpperCase();
  if (s.startsWith('XYZ:')) s = s.slice(4);
  if (s.endsWith('USDT')) s = s.slice(0, -4);
  return HIP3_ASSETS[s]?.category || 'crypto';
}

export const CATEGORY_LABELS = {
  all: 'All',
  crypto: 'Crypto',
  stock: 'Stocks',
  commodity: 'Commodities',
  index: 'Indices',
  forex: 'Forex',
  etf: 'ETF',
};

export const CATEGORY_TABS = Object.entries(CATEGORY_LABELS);
